import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductVariantShort } from "../../../common/common-product/models/product-short.model";
import { ProductVariantDeliverableModel } from "../../models/product-variant-deliverable.model";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Actions, ofActionSuccessful, Store } from "@ngxs/store";
import {
  GetProductVariantDeliverable,
  GetProductVariantDeliverableSuccess,
  OnSelectedVariantChange
} from "../../actions/product-details.actions";

@Component({
  selector: 'leap-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent implements OnInit, OnDestroy {

  @Input() productVariantDeliverablesPending : Observable<boolean>;
  @Input() selectedVariant : ProductVariantShort;
  @Input() deliverables : Map<string, Array<ProductVariantDeliverableModel>>;

  public ngUnsubscribe = new Subject();
  public contentWrapper = [];

  constructor(private store: Store, private changeDetectorRef: ChangeDetectorRef, private actions$: Actions) { }

  ngOnInit() {
    this.listenToSelectedVariant();
    this.store.dispatch(new GetProductVariantDeliverable(this.selectedVariant.sku));
  }

  listenToSelectedVariant() {
    this.actions$.pipe(
        ofActionSuccessful(OnSelectedVariantChange),
        takeUntil(this.ngUnsubscribe)
    ).subscribe((_: OnSelectedVariantChange) => {
      console.log(_);
      this.store.dispatch(new GetProductVariantDeliverable(_.variant.sku));
    });

    this.actions$.pipe(
        ofActionSuccessful(GetProductVariantDeliverableSuccess),
        takeUntil(this.ngUnsubscribe)
    ).subscribe((_: GetProductVariantDeliverableSuccess) => {
        this.buildDeliverableWrapper(_.deliverables);
    });
  }

  buildDeliverableWrapper(deliverables : Array<ProductVariantDeliverableModel>) {

    this.contentWrapper.length = 0;
    deliverables.map((dItem) => {
      this.contentWrapper.push({
        title: dItem.deliverable.deliverableName,
        contentList: this.buildContentWrapper(dItem.deliverable.contents, dItem.deliverable.previewPath),
        active: false
      });
    });
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  buildContentWrapper(contentArray: any, previewPath: string) {
    let contentList = [];
    contentArray
      .filter(item => item.contentType.configKey != 'coverpage')
      .map(item => {
      contentList.push({
        name : item.displayName,
        path : previewPath
      })
    });
    return contentList;
  }

}
